export default "__VITE_ASSET__fa4bd3fe__"